import React, { useContext, useState } from 'react';
import { Message } from 'talkplus-sdk/dist/model/types';
import ReactionMenu from '@components/chat/chatDetail/messageList/reactionMenu';
import ReactionList from '@components/chat/chatDetail/messageList/reactionList';
import useChatReactionState from '@components/chat/hooks/useChatReactionState';
import { ChatContext, ChatContextType } from '@components/chat/ChatContext';

interface useChatReactionMenuProps {
  message: Message;
  isReplying?: boolean;
  handleReply: (message: Message) => void;
}

// 채팅 메시지에 대한 리액션 메뉴를 보여주는 커스텀 훅
const useChatReactionMenu = ({ message, isReplying, handleReply }: useChatReactionMenuProps) => {
  const { userData } = useContext<ChatContextType>(ChatContext);
  const userId = userData?.user.id;

  const [isHovered, setIsHovered] = useState<boolean>(false);
  const [reactionSubmenuVisible, setReactionSubmenuVisible] = useState(false);

  const { reactionsState, addReactionState, removeReactionState, isReaction } = useChatReactionState({
    message,
    userId,
  });

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    if (reactionSubmenuVisible) return;
    setIsHovered(false);
  };

  const getReactionMenuEl = (positionType?: 'left' | 'right') => {
    if (!isHovered) return null;
    return (
      <ReactionMenu
        positionType={positionType}
        message={message}
        reactionsState={reactionsState}
        addReactionState={addReactionState}
        removeReactionState={removeReactionState}
        isReplying={isReplying}
        handleReply={() => handleReply(message)}
        setIsHovered={setIsHovered}
        reactionSubmenuVisible={reactionSubmenuVisible}
        setReactionSubmenuVisible={setReactionSubmenuVisible}
      />
    );
  };

  const getReactionListEl = (positionType?: 'left' | 'right') => {
    if (!isReaction) return null;
    return (
      <ReactionList
        positionType={positionType}
        message={message}
        reactionsState={reactionsState}
        addReactionState={addReactionState}
        removeReactionState={removeReactionState}
      />
    );
  };

  return {
    isReaction,
    isHovered,
    handleMouseEnter,
    handleMouseLeave,
    getReactionMenuEl,
    getReactionListEl,
  };
};

export default useChatReactionMenu;
